import React, { useState, useEffect } from 'react'
import {Form, Button} from "react-bootstrap";
import axios from 'axios';
import {useTranslation} from "react-i18next";
import '../ModemSettings.css';
import Switch from "react-switch";


function NebosvodSettings({drone, isNebosvodAuth, nebosvodAuthLogin, onNebosvodAuth}){
    const { t } = useTranslation(['modem']);

    const [nebosvodModemSaveInfo, setNebosvodModemSaveInfo] = useState("");
    const [isNebosvodVis, setIsNobosvodVis] = useState(drone.nebosvodInfo?.isVis ?? false);
    const [nebosvodOprtnId, setNebosvodOprtnId] = useState(drone.nebosvodInfo?.oprtnId ?? "");
    const [nebosvodSerNum, setNebosvodSerNum] = useState(drone.nebosvodInfo?.serNum ?? "");
    const [nebosvodRegIndex, setNebosvodRegIndex] = useState(drone.nebosvodInfo?.regIndex ?? "");
    const [nebosvodLogin, setNebosvodLogin] = useState("");
    const [nebosvodPass, setNebosvodPass] = useState("");
    const [nebosvodSaveInfo, setNebosvodSaveInfo] = useState("");

    useEffect(() => {
        setIsNobosvodVis(drone.nebosvodInfo?.isVis ?? false)
        setNebosvodOprtnId(drone.nebosvodInfo?.oprtnId ?? "")
        setNebosvodSerNum(drone.nebosvodInfo?.serNum ?? "")
        setNebosvodRegIndex(drone.nebosvodInfo?.regIndex ?? "")
    }, [drone]);

    function nebosvodLogOut(){
        axios.post('api/nebosvod/logOut')
        .then(response => {
            window.location.reload();
        })
        .catch(exception => {
            setNebosvodModemSaveInfo(t('logout_error'));
        });
    }

    function switchNebosvodVis(){
        setIsNobosvodVis(!isNebosvodVis)
    }

    function saveNebosvodModemInfo(){
        axios.post('api/nebosvod/saveNebosvodModemInfo', {serNum: nebosvodSerNum, regIndex: nebosvodRegIndex, oprtnId: nebosvodSerNum, imei: drone.imei, isVis: isNebosvodVis})
        .then(response => {
            setNebosvodModemSaveInfo(t('successfully'));
        })
        .catch(exception => {
            setNebosvodModemSaveInfo(t('login_or_pass_error'));
        });
    }

    function loginNebosvod(){
        axios.post('api/nebosvod/getToken', {password: nebosvodPass, login: nebosvodLogin})
        .then(response => {
            setNebosvodSaveInfo(t('successfully'));
            onNebosvodAuth(nebosvodLogin)
        })
        .catch(exception => {
            setNebosvodSaveInfo(t('error'));
        });
    }

    return(
        <div className='nebosvod'>
            {isNebosvodAuth ? 
            <>
                <div className='t-18 ts-16'>Логин в системе <a href='https://skyarc.ru/' target="_blank">Небосвод:</a> {nebosvodAuthLogin}</div>
                <div className='settings-grid ts-35'>
                    <Button onClick={nebosvodLogOut}>Выход</Button>
                </div>
                

                <div className='t-18 ts-16'>Серийный номер по CTA-2063-A или в формате производителя: </div>
                <div className='settings-grid ts-40'>
                    <div className='grid-4'>
                        <Form.Control type="text" placeholder={nebosvodSerNum} onChange={(event) => {setNebosvodSerNum(event.target.value)}} />
                    </div>
                </div>
                <div className='t-18 ts-16'>Регистрационный знак или учетный номер БВС: </div>
                <div className='settings-grid ts-16'>
                    <div className='grid-4'>
                        <Form.Control type="text" placeholder={nebosvodRegIndex} onChange={(event) => {setNebosvodRegIndex(event.target.value)}} />
                    </div>
                </div>

                <div className='settings-grid ts-16'>
                    <Button onClick={saveNebosvodModemInfo}>Сохранить</Button>
                    <div className='grid-ogn'>
                        <div className='ogn-switch'>
                            <Switch onChange={() => {switchNebosvodVis()}} checked={isNebosvodVis} uncheckedIcon={false} checkedIcon={false} onColor='#EBFF00' onHandleColor='#000000' offHandleColor='#000000' offColor='#494949'/>
                        </div>
                        <div className='t-18'>
                            Отправлять данные в систему "Небосвод"
                        </div>
                    </div>
                </div>
        
                <div className='t-18 ts-16'>{nebosvodModemSaveInfo}</div>
            </> : 
            <>
                <div className='t-18 ts-16'>Введите данные системы <a href='https://skyarc.ru/' target="_blank">Небосвод:</a> </div>
                <div className='t-18 ts-16'>Логин: </div>
                <div className='settings-grid ts-16'>
                    <div className='grid-4'>
                        <Form.Control type="text" placeholder={nebosvodLogin} onChange={(event) => {setNebosvodLogin(event.target.value)}} />
                    </div>
                </div>
                <div className='t-18 ts-16'>Пароль: </div>
                <div className='settings-grid ts-16'>
                    <div className='grid-4'>
                        <Form.Control type="password" placeholder={nebosvodPass} onChange={(event) => {setNebosvodPass(event.target.value)}} />
                    </div>
                </div>
                <div className='settings-grid ts-35'>
                    <Button onClick={loginNebosvod}>Войти</Button>
                </div>
                <div>{nebosvodSaveInfo}</div>
            </>}
            
        </div>
    )
}

export default NebosvodSettings;
